export default __webpack_public_path__ + "static/media/Licenses_BG-02.3b58a7fc.png";